module.exports = __webpack_public_path__ + "static/media/avatar.d7ceab67.png";